// ABOUTME: JSON fetch helper of the CPQ REST hooks; a `success: false` answer throws an ApiError.
// ABOUTME: The error keeps the HTTP status and the body, e.g. the 409 OFFER_MARKET_MISMATCH details.

export interface ApiResponse<T> {
    success: boolean;
    data?: T;
    error?: string;
    message?: string;
    code?: string;
    [key: string]: unknown;
}

/** A CPQ REST call answered `success: false`; the message is the server's `error`. */
export class ApiError extends Error {
    readonly status: number;

    readonly body: ApiResponse<unknown>;

    constructor(status: number, body: ApiResponse<unknown>) {
        super(body.error ?? 'Unknown error');
        this.name = 'ApiError';
        this.status = status;
        this.body = body;
    }
}

export async function apiFetch<T>(url: string, options?: RequestInit): Promise<T> {
    const response = await fetch(url, {
        headers: { 'Content-Type': 'application/json' },
        ...options,
    });
    const json: ApiResponse<T> = await response.json();
    if (!json.success) {
        throw new ApiError(response.status, json as ApiResponse<unknown>);
    }
    return json.data as T;
}
